import { FormAwareRadioGroup } from '@/components/form/formAwareInputs/FormAwareRadioGroup';
import { useFormContext } from '@/components/react-hook-form';
import { PresentationApprovalRequirement } from '@/types/schema';

import { ApplicationConfigurationFormShape } from './ApplicationConfigurationFormFields';

// The three values make approval without attestation impossible to select.
const PRESENTATION_REVIEW_OPTIONS = [
  {
    value: PresentationApprovalRequirement.NotRequired,
    label: 'No review required',
    helpText: 'Presentations do not show a draft label.',
  },
  {
    value: PresentationApprovalRequirement.AttestationOnly,
    label: 'Review confirmation only',
    helpText:
      'Presentations show a "Draft" watermark until a user has confirmed that they have reviewed the presentation.',
  },
  {
    value: PresentationApprovalRequirement.AttestationAndApproval,
    label: 'Review confirmation and specialist approval',
    helpText:
      'Presentations show a "Draft" watermark until a user with approval rights approves the presentation.',
  },
];

export function PresentationReviewField() {
  const { control } = useFormContext<ApplicationConfigurationFormShape>();

  return (
    <FormAwareRadioGroup<ApplicationConfigurationFormShape>
      control={control}
      label="Presentation review"
      fieldName="requirePresentationApproval"
      options={PRESENTATION_REVIEW_OPTIONS}
      columnSpacing={1}
      row={false}
    />
  );
}
